import { render, staticRenderFns } from "./PortfolioWall.vue?vue&type=template&id=239b9be1&scoped=true&"
import script from "./PortfolioWall.vue?vue&type=script&lang=js&"
export * from "./PortfolioWall.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioWall.vue?vue&type=style&index=0&id=239b9be1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239b9be1",
  null
  
)

export default component.exports